import { GlobalSearchResultsType } from "types/SearchTypes";
import { API_URL, throwFetchError } from "./common";

const ENDPOINT = `${API_URL}/v1/ecommerce/search`;

// EE-222 - top-bar global search. The backend token-AND matches the query
// across orders/parts/customers, and a leading "#" pins the orders group to
// that one order while parts/customers still match the digits. That split
// lives in the backend, so the raw query - including any leading "#" - must
// reach it untouched aside from URI-encoding.
export const apiGlobalSearch = (
  token: string,
  query: string
): Promise<GlobalSearchResultsType> => {
  return fetch(`${ENDPOINT}?q=${encodeURIComponent(query)}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then((res) => {
    if (res.ok) return res.json();
    else return throwFetchError(res);
  });
};
